import {MoreList} from "@/components/moreList/MoreList.tsx";
import {Tag} from "@/components/Tag.tsx";
import {ServiceTag} from "@/lib/types/checks.ts";

type ChecksTagsProps = {
  tags: ServiceTag[];
};

export const ChecksTags = ({tags}: ChecksTagsProps) => {
  return (
    <MoreList
      entries={tags}
      variant="tooltip"
      renderer={(tag: ServiceTag) => <Tag text={tag.tag} iconColor={tag.color_hex} />}
    />
  );
};
